import React from "react";

import Caroussel from "../components/componentshome/Caroussel";
import Intro from "../components/componentshome/Intro";
import FeaturedProperties from "../components/FeaturedProperties";
import FeaturedResaleProperties from "../components/FeaturedResaleProperties";
import FeaturedRusticProperties from "../components/FeaturedRusticProperties";
import FeaturedContemporaryProperties from "../components/FeaturedContemporaryProperties";
import WhyCostaBlanca from "../components/componentshome/WhyCostaBlanca";
import AboutCostaBlanca from "../components/componentshome/AboutCostaBlanca";
import AboutPascal from "../components/componentshome/AboutPascal";
import { motion } from "framer-motion";

function Home() {
  const fadeInUp = {
    hidden: { opacity: 1, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };
  return (
    <div className="Home">
      <Caroussel />
      <Intro />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <FeaturedProperties />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <FeaturedContemporaryProperties />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <FeaturedRusticProperties />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <FeaturedResaleProperties />
      </motion.div>

      <WhyCostaBlanca />
      <AboutCostaBlanca />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.01 }}
        variants={fadeInUp}
      >
        <AboutPascal />
      </motion.div>
    </div>
  );
}

export default Home;
